import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import Hidden from '@material-ui/core/Hidden';
import { get } from 'lodash';
import Typography from '../../../components/atoms/Typography';
import { COMPONENT_NAME } from './locators';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Grid from '../../../components/molecules/Grid';
import Box from '../../../components/molecules/Box';
import Picture from '../../../components/atoms/Picture';
import { pageContentType } from '../../../utils/getContentType';
import { ATTRIBUTE_TYPE, EVENT_LISTING_TEMPLATE_ID, EVENT_TYPE } from '../../../../constants/index';
import useStyles from './style';

const PageHeading = ({ sitecoreContext }) => {
  const classes = useStyles();
  const contentType = pageContentType({ sitecoreContext }).toLowerCase();
  const eventListingTemplateId = get(sitecoreContext, 'route.templateId', '');
  const eventAdCalenderLogo = get(sitecoreContext, 'route.fields.eventAdCalenderLogo.value.src', '');
  const eventAdCalenderLogoMobile = get(sitecoreContext, 'route.fields.eventAdCalenderLogoMobile.value.src', '');
  let title =
    get(sitecoreContext, 'route.fields.pageHeading.value', '') ? get(sitecoreContext, 'route.fields.pageHeading', '') : get(sitecoreContext, 'route.fields.name', '');
  if (contentType === ATTRIBUTE_TYPE) {
    title = { value: get(sitecoreContext, 'tag', '') };
  }

  return (
    <Grid data-locator={COMPONENT_NAME}>
      <Grid container spacing={0}>
        <Grid item xs={12} className={contentType === EVENT_TYPE && eventListingTemplateId === EVENT_LISTING_TEMPLATE_ID ? classes.eventListingLogoWrapper : ''}>
          <Box pb={{ xs: 5 }}>
            <Typography wordBreak title={title.value} className={classes.headingTitle} variant="h2" component="h1" gutterBottom={false}>
              {title && <Text field={title} />}
            </Typography>
          </Box>
          {eventListingTemplateId === EVENT_LISTING_TEMPLATE_ID && contentType === EVENT_TYPE &&
            <>
              <Hidden mdDown implementation="css">
                <Box pb={{ xs: 5 }} className={classes.imageWrapper}>
                  <Picture
                    media={{
                      image: {
                        value: {
                          src: eventAdCalenderLogo,
                        },
                      },
                      renditionNeeded: false,
                      fallbackBackgroundNeeded: false,
                    }}
                    isParalax={false}
                    alternateAltText={title && title.value}
                  />
                </Box>
              </Hidden>
              <Hidden lgUp implementation="css">
                <Box pb={{ xs: 5 }} className={classes.imageWrapper}>
                  <Picture
                    media={{
                      image: {
                        value: {
                          src: eventAdCalenderLogoMobile,
                        },
                      },
                      renditionNeeded: false,
                      fallbackBackgroundNeeded: false,
                    }}
                    alternateAltText={title && title.value}
                  />
                </Box>
              </Hidden>
            </>
          }

        </Grid>
      </Grid>
    </Grid>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(PageHeading))
);
